export interface FinanceHubCustomerRow {
  accountIdLabel: string;
  addressLabel: string | null;
  chatId: string;
  customerNameLabel: string;
  hasAutopay: boolean;
  hasContactInfo: boolean;
  hasPaymentMethod: boolean;
  hasPaymentPlan: boolean;
  hasStatement: boolean;
  invoiceCount: number;
  outstandingInMicros: number;
  outstandingLabel: string;
}

export type CustomerSortField =
  | 'accountId'
  | 'autopay'
  | 'contactInfo'
  | 'customerName'
  | 'invoiceCount'
  | 'outstanding'
  | 'paymentMethod'
  | 'paymentPlan'
  | 'statement';

export interface CustomerSort {
  direction: 'asc' | 'desc';
  field: CustomerSortField;
}

export type CustomerPresenceFilter = 'all' | 'missing' | 'onFile';

export type CustomerYesNoFilter = 'all' | 'no' | 'yes';

export interface CustomerFilters {
  autopay: CustomerYesNoFilter;
  contactInfo: CustomerPresenceFilter;
  paymentMethod: CustomerPresenceFilter;
  paymentPlan: CustomerYesNoFilter;
  statement: CustomerYesNoFilter;
}

export type CustomerFilterField = keyof CustomerFilters;

export const DEFAULT_CUSTOMER_FILTERS: CustomerFilters = {
  autopay: 'all',
  contactInfo: 'all',
  paymentMethod: 'all',
  paymentPlan: 'all',
  statement: 'all',
};
